import React, { useState } from 'react';
import messages from 'translations/messages';
import { FormattedMessage } from 'react-intl';

import { Steps, Button } from 'antd';

import './style.less';

const StepsWizard = ({ steps, initalKey, onChange, onNext, prevLabel, onPrev }) => {
  const [activeStep, setActiveStep] = useState(initalKey || 0);

  const handleChange = (index) => {
    setActiveStep(index);
    onChange(index);
  };

  const next = async () => {
    try {
      let goNext = true;
      if (onNext) {
        goNext = await onNext(activeStep);
      }

      if (goNext !== false && activeStep !== steps.length - 1) {
        handleChange(activeStep + 1);
      }
    } catch (e) { // Don't proceed if onNext throws.
      console.log(e);
    }
  };

  const prev = () => {
    if (onPrev) { onPrev(activeStep); }
    if (activeStep !== 0) {
      setActiveStep(activeStep - 1);
    }
  };

  return (
    <div className="steps-wizard">
      <Steps className="steps" type="navigation" current={activeStep} onChange={handleChange} items={steps.map(s => ({ key: s.key, title: s.title, disabled: s.disabled, icon: s.icon }))} />
      <div className="steps-content">
        {steps[activeStep].render()}
      </div>

      <div className="steps-actions">
        <Button onClick={prev} disabled={activeStep === 0}>
          {prevLabel || <FormattedMessage {...messages.back} />}
        </Button>
        <Button type="primary" onClick={next}>
          {steps[activeStep].nextLabel || <FormattedMessage {...messages.save} />}
        </Button>
      </div>
    </div>
  );
};

export default StepsWizard;
